import { Observable, BehaviorSubject, of as observableOf, of } from 'rxjs';
import { mergeMap, catchError, share, filter } from "rxjs/operators";
import { addProvider, IProviderDescriptor } from "../ServiceUtil";
import { BenchEmployeeDelegate } from "./bench-employee.delegate";
import
{
    IBenchEmployee,
    IBenchEmployeeResponse,
    INewBenchEmployeeDocument,

    IBenchEmployeeSubmission,
    IBenchEmployeeInterview,
    IBenchLead,
    IBenchLeadResponse,
    IBenchInterviewResponse,
    INewBenchLeadBulk,
    IBenchSearchResponse
} from "./bench-employee.interface";
import { AuthenticationService } from "../AuthenticationService";

export class BenchEmployeeService
{
    private benchEmployeesData: IBenchEmployee[] = null;
    private benchEmployeesSubject: BehaviorSubject<IBenchEmployee[]> = new BehaviorSubject(null);
    public benchEmployees: Observable<IBenchEmployee[]> = this.benchEmployeesSubject.pipe(filter((data) => !!data));

    private benchEmployeesFilterSubject: BehaviorSubject<IBenchEmployee[]> = new BehaviorSubject(null);
    public benchEmployeesFiltered: Observable<IBenchEmployee[]> = this.benchEmployeesFilterSubject.pipe(filter((data) => !!data));

    private selectedBenchEmployeeId: string = '0';
    private selectedBenchType: string;
    private benchDataForBenchType: string;
    private benchEmployeesSubmssionData: IBenchEmployeeSubmission[] = null;
    private benchEmployeesSubmissionSubject: BehaviorSubject<IBenchEmployeeSubmission[]> = new BehaviorSubject(null);
    public benchEmployeesSubmission: Observable<IBenchEmployeeSubmission[]> = this.benchEmployeesSubmissionSubject.pipe(filter((data) => !!data));


    private benchLeadsData: IBenchLead[] = null;
    private benchLeadsSubject: BehaviorSubject<IBenchLead[]> = new BehaviorSubject(null);
    public benchLeads: Observable<IBenchLead[]> = this.benchLeadsSubject.pipe(filter((data) => !!data));

    private benchInterviewsData: IBenchEmployeeInterview[] = null;
    private benchInterviewsSubject: BehaviorSubject<IBenchEmployeeInterview[]> = new BehaviorSubject(null);
    public benchInterviews: Observable<IBenchEmployeeInterview[]> = this.benchInterviewsSubject.pipe(filter((data) => !!data));


    private selectedBenchEmployeeData: IBenchEmployee = null;
    private selectedBenchEmployeeSubject: BehaviorSubject<IBenchEmployee> = new BehaviorSubject(this.selectedBenchEmployeeData);
    public selectedBenchEmployee: Observable<IBenchEmployee> = this.selectedBenchEmployeeSubject;

    private selectedBenchLeadId: string = '0';


    private benchLeadData: IBenchLead = null;
    private benchLeadSubject: BehaviorSubject<IBenchLead> = new BehaviorSubject(null);
    public benchLead: Observable<IBenchLead> = this.benchLeadSubject.pipe(filter((data) => !!data));


    private acceptedBenchEmployeesSubmssionData: IBenchEmployeeSubmission[] = null;
    private acceptedBenchEmployeesSubmssionSubject: BehaviorSubject<IBenchEmployeeSubmission[]> = new BehaviorSubject(null);
    public acceptedBenchEmployeesSubmssion: Observable<IBenchEmployeeSubmission[]> =
        this.acceptedBenchEmployeesSubmssionSubject.pipe(filter((data) => !!data));


    private stageBenchEmployeesSubmssionData: IBenchEmployeeSubmission[] = null;
    private stageBenchEmployeesSubmssionSubject: BehaviorSubject<IBenchEmployeeSubmission[]> =
        new BehaviorSubject(null);
    public stageBenchEmployeesSubmssion: Observable<IBenchEmployeeSubmission[]> =
        this.stageBenchEmployeesSubmssionSubject.pipe(filter((data) => !!data));

    private benchEmployeesSearchData: IBenchEmployee[] = null;
    private benchEmployeesSearchSubject: BehaviorSubject<IBenchEmployee[]> = new BehaviorSubject(null);
    public benchEmployeesSearch: Observable<IBenchEmployee[]> = this.benchEmployeesSearchSubject.pipe(filter((data) => !!data));

    private benchLeadsSearchData: IBenchLead[] = null;
    private benchLeadsSearchSubject: BehaviorSubject<IBenchLead[]> = new BehaviorSubject(null);
    public benchLeadsSearch: Observable<IBenchLead[]> = this.benchLeadsSearchSubject.pipe(filter((data) => !!data));


    constructor(private benchEmployeeDelegate: BenchEmployeeDelegate,
        private authenticationService: AuthenticationService)
    {

    }

    public get benchEmployeeId(): string
    {
        return this.selectedBenchEmployeeId;
    }


    public get benchLeadId(): string
    {
        return this.selectedBenchLeadId;
    }
    public get benchType(): string
    {
        return this.selectedBenchType;
    }

    public setSelectedBenchLeadeId(benchLeadId: string): void
    {
        this.selectedBenchLeadId = benchLeadId;
    }

    public getBenchLeadById(benchLeadId: string = ''): Observable<boolean>
    {
        if (benchLeadId === "0")
        {
            this.benchLeadData = null;
            this.benchLeadSubject.next(this.benchLeadData);
            return observableOf(false);
        }
        const response = this.benchEmployeeDelegate.getBenchLeadById(benchLeadId);
        return this.processBenchLead(response);
    }

    private processBenchLead(salesRep: Observable<IBenchLeadResponse>): Observable<boolean>
    {
        salesRep.subscribe(onSuccess.bind(this), onFault.bind(this));

        return salesRep.pipe(mergeMap((response: IBenchLeadResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(salesRepResponse: IBenchLeadResponse)
        {
            if (salesRepResponse.success)
            {
                this.benchLeadData = salesRepResponse.benchLead;
                this.selectedBenchLeadId = salesRepResponse.benchLeadId;
                this.benchLeadSubject.next(this.benchLeadData);
            }
        }

        function onFault(error: any)
        {
            //SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }

    public getSelectedBenchEmployee(): IBenchEmployee
    {
        return this.benchEmployeesData ?
            this.benchEmployeesData.find((benchEmployee: IBenchEmployee) => benchEmployee.benchEmployeeId === this.selectedBenchEmployeeId)
            : undefined;
    }

    public setSelectedBenchType(benchType: string): void
    {
        this.selectedBenchType = benchType;
    }


    public setSelectedBenchEmployeeId(benchEmployeeId: string): void
    {
        this.selectedBenchEmployeeId = benchEmployeeId;
        //const selectedEmployee = this.getSelectedBenchEmployee();
        //if (selectedEmployee && selectedEmployee.benchEmployeeSubmission)
        //{
        //    this.benchEmployeesSubmssionData = selectedEmployee.benchEmployeeSubmission;
        //    this.benchEmployeesSubmissionSubject.next(this.benchEmployeesSubmssionData);
        //}
    }

    public getAllBenchInterviwes(
        fromDate: Date | string): Observable<boolean>
    {

        const orgId = this.authenticationService.GetOrgId();
        const response = this.benchEmployeeDelegate.getAllBenchInterviwes(orgId, this.authenticationService.GetSalesRepId(), fromDate);

        return this.processBenchInterviwes(response);
    }

    public getAllBenchEmployees(benchType: 'raw' | 'training' | 'marketing' | 'placement' | 'declined' | 'salesRep',
        hardReload: boolean = false): Observable<boolean>
    {
        if (this.benchEmployeesData !== null &&
            this.benchEmployeesData.length > 0 &&
            hardReload === false &&
            this.benchDataForBenchType === benchType)
        {
            return of(true);
        }
        const orgId = this.authenticationService.GetOrgId();
        this.benchDataForBenchType = benchType;
        const response = this.benchEmployeeDelegate.getAllBenchEmployees(orgId, benchType, this.authenticationService.GetSalesRepId());

        return this.processBenchEmployees(response);
    }

    public getBenchSearch(searchKey: string): Observable<boolean>
    {
        const orgId = this.authenticationService.GetOrgId();
        const response = this.benchEmployeeDelegate.getSalesSearch(orgId, searchKey);

        return this.processBenchSearch(response);
    }


    public getBenchEmployeeDetailsById(benchEmployeeId: string): Observable<boolean>
    {
        if (benchEmployeeId === "0")
        {
            this.selectedBenchEmployeeData = null;
            this.selectedBenchEmployeeSubject.next(this.selectedBenchEmployeeData);
            return observableOf(false);
        }
        var response = this.benchEmployeeDelegate.getBenchEmployeeById(benchEmployeeId);

        return this.processBenchEmployee(response);
    }

    public createNewBenchEmployee(benchEmployee: IBenchEmployee): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.createNewBenchEmployee({ ...benchEmployee, ...this.authenticationService.getBaseRequest });
        return this.processBenchEmployees(response);
    }

    public updateBenchEmployee(benchEmployee: IBenchEmployee): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.updateBenchEmployee({ ...benchEmployee, ...this.authenticationService.getBaseRequest });
        return this.processBenchEmployee(response);
    }

    public getAllBenchLeads(hardReload: boolean = false): Observable<boolean>
    {
        if (this.benchLeadsData !== null &&
            this.benchLeadsData.length > 0 &&
            hardReload === false)
        {
            return of(true);
        }
        const orgId = this.authenticationService.GetOrgId();
        const response = this.benchEmployeeDelegate.getAllBenchLeads(orgId);

        return this.processBenchLeads(response);
    }

    public createNewBenchLead(benchLead: IBenchLead): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.createNewBenchLead({ ...benchLead, ...this.authenticationService.getBaseRequest });
        return this.processBenchLeads(response);
    }

    public createNewBenchLeadBulk(benchLead: INewBenchLeadBulk): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.createNewBenchLeadBulk({ ...benchLead, ...this.authenticationService.getBaseRequest });
        return this.processBenchLeads(response);
    }


    public updateBenchLead(benchLead: IBenchLead): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.updateBenchLead({ ...benchLead, ...this.authenticationService.getBaseRequest });
        return this.processBenchLeads(response);
    }

    public transferBenchLead(benchLeadId: string): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.transferBenchLead(benchLeadId);
        return this.processBenchLeads(response);
    }


    public onboardEmployee(benchEmployeeId: string, benchSubmissionId: string): Observable<boolean>
    {
        const orgId = this.authenticationService.GetOrgId();
        const userid = this.authenticationService.GetUserId();

        const response = this.benchEmployeeDelegate.onboardEmployee(benchEmployeeId, benchSubmissionId, userid, orgId);

        return this.processSubmission(response);

    }

    public createNewBenchEmployeeDocuments(benchEmployeeDocs: INewBenchEmployeeDocument): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.createBenchEmployeeResume({ ...benchEmployeeDocs, ...this.authenticationService.getBaseRequest });
        return this.processBenchEmployees(response);
    }


    public createNewBenchEmployeeSubmission(benchEmployeeSubmission: IBenchEmployeeSubmission): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.createNewBenchEmployeeSubmssion({ ...benchEmployeeSubmission, ...this.authenticationService.getBaseRequest });
        return this.processBenchEmployee(response);
    }

    public updateBenchEmployeeSubmission(benchEmployeeSubmission: IBenchEmployeeSubmission): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.updateBenchEmployeeSubmssion({ ...benchEmployeeSubmission, ...this.authenticationService.getBaseRequest });
        return this.processBenchEmployee(response);
    }

    public createNewBenchEmployeeInterview(benchEmployeeInterview: IBenchEmployeeInterview): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.createNewBenchInterview({ ...benchEmployeeInterview, ...this.authenticationService.getBaseRequest });
        return this.processBenchEmployee(response);
    }

    public updateBenchEmployeeInterview(benchEmployeeInterview: IBenchEmployeeInterview): Observable<boolean>
    {
        const response = this.benchEmployeeDelegate.updateBenchInterview({ ...benchEmployeeInterview, ...this.authenticationService.getBaseRequest });
        return this.processBenchEmployee(response);
    }

    public getAcceptedSubmissions()
    {
        const orgId = this.authenticationService.GetOrgId();

        const response = this.benchEmployeeDelegate.getAcceptedSubmissions(orgId);
        return this.processSubmission(response);
    }

    public acceptStageSubmission(benchStageSubmissionId: string): Observable<boolean>
    {
        const orgId = this.authenticationService.GetOrgId();
        const userid = this.authenticationService.GetUserId();

        const response = this.benchEmployeeDelegate.acceptBenchSubmission(benchStageSubmissionId, userid, orgId);

        return this.processStageSubmission(response);

    }

    public getStageSubmissions()
    {
        const orgId = this.authenticationService.GetOrgId();

        const response = this.benchEmployeeDelegate.getStageSubmissions(orgId);
        return this.processStageSubmission(response);
    }


    private processStageSubmission(salesReps: Observable<IBenchEmployeeResponse>): Observable<boolean>
    {
        salesReps.subscribe(onAccountManagersSuccess.bind(this), onAccountManagersFault.bind(this));

        return salesReps.pipe(mergeMap((response: IBenchEmployeeResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onAccountManagersSuccess(response: IBenchEmployeeResponse)
        {
            if (response.success)
            {

                this.stageBenchEmployeesSubmssionData = response.benchEmployeeSubmission;
                this.stageBenchEmployeesSubmssionSubject.next(this.stageBenchEmployeesSubmssionData);

            }
        }

        function onAccountManagersFault(error: any)
        {
            // SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }


    private processSubmission(salesReps: Observable<IBenchEmployeeResponse>): Observable<boolean>
    {
        salesReps.subscribe(onAccountManagersSuccess.bind(this), onAccountManagersFault.bind(this));

        return salesReps.pipe(mergeMap((response: IBenchEmployeeResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onAccountManagersSuccess(response: IBenchEmployeeResponse)
        {
            if (response.success)
            {

                this.acceptedBenchEmployeesSubmssionData = response.benchEmployeeSubmission;
                this.acceptedBenchEmployeesSubmssionSubject.next(this.acceptedBenchEmployeesSubmssionData);

            }
        }

        function onAccountManagersFault(error: any)
        {
            // SalesRepService.logger.error(`processSalesReps Fault - Error (${JSON.stringify(error)})`);
        }
    }

    public filterBenchEmployees(searchTerm: string, filterBy: string)
    {
        let data = this.benchEmployeesData;
        if (filterBy == null)
        {
            data = this.benchEmployeesData.filter(x =>
                x.firstName.trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
                || x.lastName.trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
            );
        }
        else 
        {
            data = this.benchEmployeesData.filter(x =>
                x[filterBy].trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
            );
        }

        this.benchEmployeesSubject.next(data);
    }

    public filterBenchLeads(searchTerm: string, filterBy: string)
    {
        let data = this.benchLeadsData;
        if (filterBy == null)
        {
            data = this.benchLeadsData.filter(x =>
                x.firstName.trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
                || x.lastName.trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
            );
        }
        else 
        {
            data = this.benchLeadsData.filter(x =>
                x[filterBy].trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
            );
        }

        this.benchLeadsSubject.next(data);
    }

    private processBenchEmployee(response: Observable<IBenchEmployeeResponse>): Observable<boolean>
    {
        response.subscribe(onEmployeeSuccess.bind(this), onEmployeeFault.bind(this));

        return response.pipe(mergeMap((response: IBenchEmployeeResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onEmployeeSuccess(employeResponse: IBenchEmployeeResponse)
        {
            if (employeResponse.success && employeResponse.benchEmployee)
            {
                this.selectedEmployeeId = employeResponse.benchEmployeeId ? employeResponse.benchEmployeeId : this.selectedEmployeeId;
                this.selectedBenchEmployeeData = employeResponse.benchEmployee;
                this.selectedBenchEmployeeSubject.next(this.selectedBenchEmployeeData);
                if (this.selectedBenchEmployeeData && this.selectedBenchEmployeeData.benchEmployeeSubmission)
                {
                    this.benchEmployeesSubmssionData = this.selectedBenchEmployeeData.benchEmployeeSubmission;
                    this.benchEmployeesSubmissionSubject.next(this.benchEmployeesSubmssionData);
                }
                // this.setEmployeeDataInList();
            }
        }

        function onEmployeeFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }


    public setEmployeeDataInList()
    {
        let data = this.benchEmployeesData;
        const index = this.benchEmployeesData.findIndex(x => x.benchEmployeeId === this.selectedBenchEmployeeData.benchEmployeeId);
        this.benchEmployeesData[index] = this.selectedBenchEmployeeData;
        // data = this.benchEmployeesData.filter(x => x.active === this.filterEmployeStatus);

        this.benchEmployeesFilterSubject.next(data);
    }

    private processBenchSearch(benchEmployees: Observable<IBenchSearchResponse>): Observable<boolean>
    {
        benchEmployees.subscribe(onBenchEmployeesSuccess.bind(this), onBenchEmployeesFault.bind(this));

        return benchEmployees.pipe(mergeMap((response: IBenchSearchResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onBenchEmployeesSuccess(benchEmployeeResponse: IBenchSearchResponse)
        {
            if (benchEmployeeResponse.success)
            {

                this.benchEmployeesSearchData = benchEmployeeResponse.benchEmployees;
                this.benchEmployeesSearchSubject.next(this.benchEmployeesSearchData);

                this.benchLeadsSearchData = benchEmployeeResponse.benchLeads;
                this.benchLeadsSearchSubject.next(this.benchLeadsSearchData);
            }
        }

        function onBenchEmployeesFault(error: any)
        {
            //   BenchEmployeeService.logger.error(`processBenchEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processBenchEmployees(benchEmployees: Observable<IBenchEmployeeResponse>): Observable<boolean>
    {
        benchEmployees.subscribe(onBenchEmployeesSuccess.bind(this), onBenchEmployeesFault.bind(this));

        return benchEmployees.pipe(mergeMap((response: IBenchEmployeeResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onBenchEmployeesSuccess(benchEmployeeResponse: IBenchEmployeeResponse)
        {
            if (benchEmployeeResponse.success)
            {
                this.selectedBenchEmployeeId = benchEmployeeResponse.benchEmployeeId ?
                    benchEmployeeResponse.benchEmployeeId :
                    this.selectedBenchEmployeeId;
                this.benchEmployeesData = benchEmployeeResponse.benchEmployees;
                this.benchEmployeesSubject.next(this.benchEmployeesData);
                this.benchEmployeesFilterSubject.next(this.benchEmployeesData);
                const selectedEmployee = this.selectedBenchEmployeeId ? this.getSelectedBenchEmployee() : undefined;
                if (selectedEmployee && selectedEmployee.benchEmployeeSubmission)
                {
                    this.benchEmployeesSubmssionData = selectedEmployee.benchEmployeeSubmission;
                    this.benchEmployeesSubmissionSubject.next(this.benchEmployeesSubmssionData);
                }
            }
        }

        function onBenchEmployeesFault(error: any)
        {
            //   BenchEmployeeService.logger.error(`processBenchEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }



    private processBenchLeads(benchLeads: Observable<IBenchLeadResponse>): Observable<boolean>
    {
        benchLeads.subscribe(onBenchLeadSuccess.bind(this), onBenchLeadFault.bind(this));

        return benchLeads.pipe(mergeMap((response: IBenchLeadResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onBenchLeadSuccess(benchLeadResponse: IBenchLeadResponse)
        {
            if (benchLeadResponse.success)
            {
                this.selectedBenchLeadId = benchLeadResponse.benchLeadId ?
                    benchLeadResponse.benchLeadId :
                    this.selectedBenchLeadId;
                this.benchLeadsData = benchLeadResponse.benchLeads;
                this.benchLeadsSubject.next(this.benchLeadsData);
                // this.benchEmployeesFilterSubject.next(this.benchEmployeesData);

            }
        }

        function onBenchLeadFault(error: any)
        {
            //  BenchEmployeeService.logger.error(`processBenchLeads Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processBenchInterviwes(response: Observable<IBenchInterviewResponse>): Observable<boolean>
    {
        response.subscribe(onSuccess.bind(this), onFault.bind(this));

        return response.pipe(mergeMap((response: IBenchInterviewResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(response: IBenchInterviewResponse)
        {
            if (response.success)
            {
                this.benchInterviewsData = response.benchInterviews;
                this.benchInterviewsSubject.next(this.benchInterviewsData);
            }
        }

        function onFault(error: any)
        {
            // BenchEmployeeService.logger.error(`processBenchInterviwes Fault - Error (${JSON.stringify(error)})`);
        }
    }
}